if(!customElements.get('hover-element')) {
  class HoverElement extends HTMLElement {
    constructor() {
      super();

      this._internals = this.attachInternals();
      
      this.isHovering = false;
      this.mouseX = 0;
      this.mouseY = 0;

      this.addEventListener('mouseenter', () => this.setHovering(true));
      this.addEventListener('mouseleave', () => this.setHovering(false));
      this.addEventListener('mousemove', this.setCoordinates)
    }

    setHovering(isHovering) {
      this.isHovering = isHovering;
      isHovering ? this._internals.states.add('hovering') : this._internals.states.delete('hovering');
    }

    setCoordinates(ev) {
      const { screenY: top, screenX: left } = ev;

      this.style.setProperty('--top', `${top}px`);
      this.style.setProperty('--left', `${left}px`);
    }
  }

  customElements.define('hover-element', HoverElement);
}